import React from "react";
import { CFooter } from "@coreui/react-pro";

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        {/* <a href="https://coreui.io" target="_blank" rel="noopener noreferrer">
          CoreUI
        </a> */}
        <span className="ms-1">&copy; 2021 ERP Ayam Goreng Kalasan</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        { <a href="https://lyrid.co.id" target="_blank" rel="noopener noreferrer">
          PT. Lyrid Prima Indonesia
        </a> }
      </div>
    </CFooter>
  );
};

export default React.memo(AppFooter);
